export default {
  // user_id: null,
  // key: null,
  // type: null,
  auth_data: null,
  auth_token: null,
  // filter size global
  record_size: null,
  // filter date global
  from_date: null,
  end_date: null,

  // filter per menu
  from_date_recent_location: null,
  end_date_recent_location: null,

  from_date_application_usage: null,
  end_date_application_usage: null,

  from_date_history_location: null,
  end_date_history_location: null,

  from_date_history_browsing: null,
  end_date_history_browsing: null,

  from_date_device_history: null,
  end_date_device_history: null,

  from_date_tethered_devices: null,
  end_date_tethered_devices: null,

  from_date_possible_location: null,
  end_date_possible_location: null,

  from_date_aerial_log: null,
  end_date_aerial_log: null,

  from_date_signal_status: null,
  end_date_signal_status: null,

  fcm_token: null,

  target_redirect: "index", // index / detail
  
  multi_tracking_redirect: "index", // index / detail

  // load data clients
  load_data_status_clients_list: false,
  load_data_status_clients_detail: false,
  load_data_status_clients_log_activity: false,

  // load data modules
  load_data_status_modules_list: false,
  load_data_status_modules_detail: false,

  // load data Ffunction modules
  load_data_status_function_list: false,
  load_data_status_function_detail: false,

  // load data roles
  load_data_status_roles_list: false,
  load_data_status_roles_detail: false,

  // load data users
  load_data_status_users_list: false,
  load_data_status_users_detail: false,
  load_data_status_users_log_activity: false,
  load_data_status_users_log_activity_chart: false,
  load_data_status_users_log: false,
  load_data_status_users_profile: false,

  // load data users tactical
  load_data_status_users_tactical_list: false,

  // load data acl
  load_data_status_acl_list: false,

  // load data tactical devices
  load_data_status_tactical_devices_list: false,
  load_data_status_tactical_devices_detail: false,
  load_data_status_tactical_devices_list_map: false,
  load_data_status_tactical_devices_map_location: false,

  // load data territory virtual
  load_data_status_territory_virtual_list: false,
  // for edit / update
  load_data_status_territory_virtual_detail: false,
  // for detail page & notif
  load_data_status_territory_virtual_detail_map_data: false,
  load_data_status_territory_virtual_detail_map_history: false,
  load_data_status_territory_virtual_detail_history_list: false,

  // load data case_management
  load_data_status_case_management_list: false,
  load_data_status_case_management_detail: false,

  // load data single_target
  load_data_status_single_target_list: {cancel:null,status:false, code:null},
  load_data_status_single_target_detail: false,

  load_data_status_single_monitoring_list: false,

  load_data_status_single_target_tracking_list: {},

  // load data multi_tracking
  load_data_status_multi_tracking_list: false,
  load_data_status_multi_tracking_detail: false,

  load_data_status_multi_monitoring_list: false,
  load_data_status_recent_location_es_list: false,

  // load data meeting_point
  load_data_status_meeting_point_list: false,
  load_data_status_meeting_point_detail: false,

  // load data status on result sidebar menu
  load_data_status_profile_subheader: {cancel:null,status:false, code:null},
  load_data_status_profile_subheader_name: {cancel:null,status:false, code:null},
  load_data_status_overall_app_usage: {cancel:null,status:false, code:null},
  // load_data_status_overall_data_location: false, // old
  load_data_status_overall_data_location: { // recent location with cancel
    cancel: null,
    status: false,
    code: null,
  },
  load_data_status_overall_log_recent_location: { // list log recent location
    cancel: null,
    status: false,
    code: null
  },
  // load_data_status_location: false,
  load_data_status_location: {cancel:null,status:false, code:null},
  load_data_status_location_count: {
    recent: false, // get component from recent location / state overall_data_location
    detail: false,
    history: false,
  },
  // load_data_status_browsing: false,
  load_data_status_browsing: {cancel:null,status:false, code:null},
  load_data_status_browsing_count: { // not used
    history: false,
    log: false,
    ip_address: false,
    usage: false,
    duration: false,
    access_domain: false,
  },
  // load_data_status_browsing_history: false,
  // load_data_status_browsing_log: false,
  // load_data_status_browsing_ip_address: false,
  // load_data_status_browsing_usage: false,
  // load_data_status_browsing_duration: false,
  // load_data_status_browsing_access_domain: false,
  load_data_status_device_history: {cancel:null, status:false, code:null},
  load_data_status_tethered_device: {cancel:null, status:false, code:null},
  // load_data_status_profile: false,
  load_data_status_profile: {cancel:null, status:false, code:null},
  load_data_status_profile_count: {
    identity: false,
    family: false,
  },
  load_data_status_possible_location: {cancel:null, status:false, code:null},
  load_data_status_aerial_log: {cancel:null, status:false, code:null},
  load_data_status_signal_status: {cancel:null, status:false, code:null},
  load_data_status_vehicles: {cancel:null, status:false, code:null},
  load_data_status_etle: {cancel:null, status:false, code:null},
  load_data_status_get_contact: {cancel:null, status:false, code:null},
  load_data_status_travel_history: {cancel:null, status:false, code:null},
  load_data_status_travel: {cancel:null, status:false, code:null},
  load_data_status_tokped: {cancel:null, status:false, code:null},
  load_data_status_bank_account: {cancel:null, status:false, code:null},
  load_data_status_personal_identity: {cancel:null, status:false, code:null},

  // face recognition
  // load_data_status_face_recognition: false,
  load_data_status_face_recognition: {cancel:null, status:false, code:null},

  // search by name
  load_data_status_search_by_name: false,
  load_data_status_search_by_name_filter_province: false,
  load_data_status_search_by_name_filter_city: false,
  load_data_status_search_by_name_filter_district: false,

  // search by name travel history
  load_data_status_search_by_name_travel_history: false,

  // search by name paspor
  load_data_status_search_by_name_paspor: false,

  // search by name marketplace
  load_data_status_search_by_name_marketplace: false,

  // search by name university
  load_data_status_search_by_name_university: false,

  // search by name or user name personal identity
  load_data_status_search_by_name_personal_identity: {cancel:null, status:false, code:null},
  
  // search by name pln
  load_data_status_search_by_name_pln: {cancel:null, status:false, code:null},

  // load data notification
  load_data_status_notification_list: false,
  
  // load data tracking_history_list
  load_data_status_tracking_history_list: false,
  
  // load data note_case_list
  load_data_status_note_case_list: false,

  // load data note_target_list
  load_data_status_note_target_list: false,

  // ------------------------------
  
  // clients
  clients_list: {},
  clients_detail: {},
  clients_log_activity: {},

  // modules
  modules_list: {},
  modules_detail: {},

  // function modules
  function_list: {},
  function_detail: {},

  // roles
  roles_list: {},
  roles_detail: {},

  // users
  users_list: {},
  users_detail: {},
  users_log_activity: {},
  users_log_activity_chart: {},
  users_log: {},
  users_profile: {},

  // users tactical
  users_tactical_list: {},

  // acl
  acl_list: {},

  // tactical devices
  tactical_devices_list: {},
  tactical_devices_detail: {},
  // map device location
  tactical_devices_list_map: {},
  tactical_devices_map_location: {},

  // territory virtual
  territory_virtual_list: {},
  // for edit / update
  territory_virtual_detail: {},
  // for detail page & notif
  territory_virtual_detail_map_data: {},
  territory_virtual_detail_map_history: {},
  territory_virtual_detail_history_list: {},

  // case management
  case_management_list: {},
  case_management_detail: {},

  // single target
  single_target_list: {},
  single_target_detail: {},

  single_monitoring_list: {},

  single_target_tracking_list: {},

  // multi tracking / target
  multi_tracking_list: {},
  multi_tracking_detail: {},

  multi_monitoring_list: {},
  recent_location_es_list: {},

  // meeting_point
  meeting_point_list: {},
  meeting_point_detail: {},

  // result page
  profile_subheader: {},
  profile_subheader_name: {},
  profile_identity: {},
  profile_family: {},
  overall_data_location: {},
  overall_log_recent_location: {}, // list log recent location
  overall_app_usage: {},
  location_detail: {},
  location_history: [],
  browsing_history: {},
  browsing_log: {},
  browsing_ip_address: {},
  browsing_usage: {},
  browsing_duration: {},
  browsing_access_domain: {},
  device_history: [],
  tethered_device: {},
  possible_location: {},
  aerial_log: {},
  signal_status: {},
  vehicles: [],
  vehicles_status: 'old',
  etle: [],
  get_contact: {},
  travel_history: {},
  tokped: {},
  bank_account: {},
  personal_identity: {},
  travel: [],

  // face recognition
  face_recognition: [],

  // search by name
  search_by_name: [],
  search_by_name_filter_province: [],
  search_by_name_filter_city: [],
  search_by_name_filter_district: [],
  // search_by_name_filter_year_of_birth: [],

  // search by name travel history
  search_by_name_travel_history: [],

  // search by name paspor
  search_by_name_paspor: [],

  // search by name marketplace
  search_by_name_marketplace: [],

  // search by name university
  search_by_name_university: [],

  // search by name personal_identity
  search_by_name_personal_identity: {},

  // search by name pln
  search_by_name_pln: [],

  // notification
  notification_list: {},
  notification_count: [],
  
 // tracking_history
  tracking_history_list: {},

  // note_case
  note_case_list: {},

  // note_target
  note_target_list: {},

  // download app
  download_app: {},

  // bot menu
  load_data_status_bot_menu_list:false,
  bot_menu_list: {},
}
